import { ArrowUpRight, Quotes } from "@phosphor-icons/react";

// Editorial media card. Used on /news (full) and reusable anywhere.
export const PressCard = ({ item, testId = "press-card" }) => {
  if (!item) return null;
  return (
    <article
      data-testid={testId}
      className="group border border-white/10 hover:border-[#B32027]/60 bg-[#0F0F0F] transition-colors duration-300"
    >
      {item.image && (
        <a
          href={item.url}
          target="_blank"
          rel="noreferrer noopener"
          className="block"
          data-testid={`${testId}-image-link`}
        >
          <div className="overflow-hidden bg-black">
            <img
              src={item.image}
              alt={item.imageAlt}
              loading="lazy"
              className="w-full h-auto block transition-transform duration-700 md:group-hover:scale-[1.03]"
            />
          </div>
        </a>
      )}

      {item.imageCredit && item.image && (
        <p className="px-5 md:px-8 pt-3 text-[11px] text-white/45 italic">
          {item.imageCredit}
        </p>
      )}

      <div className="px-5 md:px-8 pt-4 pb-7 md:pb-9">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2 mb-5">
          <span
            data-testid={`${testId}-outlet`}
            className="inline-flex items-center bg-[#B32027] text-white px-3 py-1.5 text-[10px] font-black uppercase tracking-[0.28em]"
          >
            {item.outlet}
          </span>
          {item.outletNote && (
            <span className="text-[10px] uppercase tracking-[0.25em] text-white/50">
              {item.outletNote}
            </span>
          )}
          {item.kicker && (
            <span className="text-[10px] uppercase tracking-[0.25em] text-white/50 border-l border-white/15 pl-3">
              {item.kicker}
            </span>
          )}
        </div>

        <h3
          data-testid={`${testId}-headline`}
          className="font-display font-black uppercase tracking-tight leading-[0.95] text-2xl md:text-4xl mb-4"
        >
          {item.headline}
        </h3>

        <p className="text-white/80 text-sm md:text-base leading-relaxed mb-5 max-w-2xl">
          {item.dek}
        </p>

        {item.excerpt && (
          <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-2xl">
            {item.excerpt}
          </p>
        )}

        {item.pullQuote && (
          <blockquote className="border-l-2 border-[#B32027] pl-5 mb-7 max-w-2xl">
            <Quotes size={18} weight="fill" className="text-[#B32027] mb-2" />
            <p className="text-white/85 text-sm md:text-base italic leading-relaxed">
              {item.pullQuote}
            </p>
            <footer className="mt-2 text-[11px] uppercase tracking-[0.2em] text-white/45">
              Alanna Johnson, founder
            </footer>
          </blockquote>
        )}

        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-5 border-t border-white/10">
          <p className="text-[11px] uppercase tracking-[0.2em] text-white/45">
            {item.author}
            {item.authorTitle ? ` · ${item.authorTitle}` : ""} · {item.dateLabel}
          </p>
          <a
            href={item.url}
            target="_blank"
            rel="noreferrer noopener"
            data-testid={`${testId}-read-link`}
            className="self-start sm:self-auto inline-flex items-center gap-2 bg-white/5 hover:bg-[#B32027] border border-white/25 hover:border-[#B32027] text-white px-5 py-3 text-[10px] font-bold uppercase tracking-[0.25em] transition-colors whitespace-nowrap"
          >
            Read the full story <ArrowUpRight size={12} weight="bold" />
          </a>
        </div>
      </div>
    </article>
  );
};

export default PressCard;
